import React from "react";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Col, Row } from "reactstrap";

export default function InvoiceDetails({ headValues }) {
  const formatDate = (strDate) => {
    if (!strDate) return "";
    const [day, month, year] = strDate.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  return (
    <div className="p-3" style={{ fontSize: "12px" }}> {/* Set font size to 12px */}
      <Row className="mb-3">
        <Col sm="3" className="font-weight-bold">Bill Date</Col>
        <Col sm="3" className="bg-light border">{formatDate(headValues.billDate) || ""}</Col>
        <Col sm="3" className="font-weight-bold">Payment Type</Col>
        <Col sm="3" className="bg-light border">{headValues.paymentType || ""}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm="3" className="font-weight-bold">Party Name</Col>
        <Col sm="3" className="bg-light border">{headValues.partyName || ""}</Col>
        <Col sm="3" className="font-weight-bold">Invoice Number</Col>
        <Col sm="3" className="bg-light border">{headValues.invoiceNumber || ""}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm="3" className="font-weight-bold">Credit Adjustments</Col>
        <Col sm="3" className="bg-light border">{headValues.creditAdjustments || "0"}</Col>
        <Col sm="3" className="font-weight-bold">Outpay Adjustments</Col>
        <Col sm="3" className="bg-light border">{headValues.outputPayAdjustments || "0"}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm="3" className="font-weight-bold">Scheme Discount</Col>
        <Col sm="3" className="bg-light border">{headValues.schemeDiscount || "0"}</Col>
        <Col sm="3" className="font-weight-bold">Shikar Scheme</Col>
        <Col sm="3" className="bg-light border">{headValues.shikarScheme || "0"}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm="3" className="font-weight-bold">Bill Value</Col>
        <Col sm="3" className="bg-light border">{headValues.billValue || "0"}</Col>
        <Col sm="3" className="font-weight-bold">Net Sales</Col>
        <Col sm="3" className="bg-light border">{headValues.netSales || "0"}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm="3" className="font-weight-bold">Sales Person Name</Col>
        <Col sm="3" className="bg-light border">{headValues.salesPersonName || "0"}</Col>
        <Col sm="3" className="font-weight-bold">Status</Col>
        <Col sm="3" className="bg-light border text-danger">{headValues.status || "0"}</Col>
      </Row>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/InvoiceDetails.js